export const DEFAULT_COUNTRY = { countryCode: 'US', countryName: 'United States' };
